const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/SynedraIFrameViewerPage/SynedraIFrameViewerPage.tsx';
import { PageLayout } from '../../layout/PageLayout';
import { AppBarMain } from '../DashboardPage/AppBar/AppBar';
import { useIntl } from 'react-intl';
import * as React from 'react';
import PageCardComponent from 'App/components/PageCard/PageCardComponent';
import textMap from 'App/pages/SynedraIFrameViewerPage/translations';
import Grid from '@mui/material/Grid';
import { css } from '@emotion/css';
import { useSynedraToken } from 'App/store/synedra';
import GoBackToDashboardButton from 'App/pages/GoBackToDashboardButton';

const iframeStyle = css`
    height: 100%;
    width: 100%;
    min-height: 750px;
`;

export const SynedraIFrameViewerPage = () => {
    const { data: synedraIFrameToken } = useSynedraToken();
    const { formatMessage } = useIntl();

    return (
        <PageLayout appBar={<AppBarMain />}>
            <Grid size={{ xs: 12 }}>
                <GoBackToDashboardButton />
                <PageCardComponent
                    title={formatMessage(textMap.title)}
                    titleIcon={'icons8-x-ray'}
                    TitleProps={{
                        className: css`
                            margin-bottom: 0;
                        `,
                    }}
                >
                    <iframe
                        sandbox="allow-same-origin allow-scripts"
                        referrerPolicy={'no-referrer'}
                        frameBorder={0}
                        className={iframeStyle}
                        src={synedraIFrameToken.iFrameUrl}
                    />
                </PageCardComponent>
            </Grid>
        </PageLayout>
    );
};
